import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import Draggable from "react-draggable";
import StepsWizard from "../../../components/scheduling/StepsWizard";
import Matching from "../../../components/scheduling/Matching";
import Details from "../../../components/scheduling/Details";
import { FormattedMessage } from "react-intl";

const EventModal = (props) => {
  const {
    activeEvent,
    visible,
    submitEvent,
    handleCancel,
    orders,
    removeEvent,
    mode,
    onChosenEmployee,
    onRemoveEmployee,
    onTariffChanged,
    onUseEmployeeTariffChanged,
    onTransportationChanged,
    onOncallChange,
    originalEmployeeId,
    patient,
    changeActiveEvent,
    type,
  } = props;

  const [disabled, setDisabled] = useState(true);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!visible) {
      setCurrent(0);
    }
  }, [visible]);
  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  const onChangeSlide = (c) => {
    setCurrent(c);
  };
  const steps = [
    {
      title: null,
      comp: (
        <Details
          orders={orders}
          activeEvent={activeEvent}
          removeEvent={removeEvent}
          mode={mode}
          type={type || "plan"}
          onChangeSlide={onChangeSlide}
          submitEvent={submitEvent}
          changeActiveEvent={changeActiveEvent}
          title={
            mode === "edit" ? (
              <FormattedMessage id="app.scheduling.editEvent" />
            ) : (
              <FormattedMessage id="app.scheduling.createNewEvent" />
            )
          }
        />
      ),
    },
    {
      title: null,
      comp: (
        <Matching
          activeEvent={activeEvent}
          onChosenEmployee={onChosenEmployee}
          onRemoveEmployee={onRemoveEmployee}
          onTariffChanged={onTariffChanged}
          onUseEmployeeTariffChanged={onUseEmployeeTariffChanged}
          onTransportationChanged={onTransportationChanged}
          onOncallChange={onOncallChange}
          onChangeSlide={onChangeSlide}
          submitEvent={submitEvent}
          orders={orders}
          originalEmployeeId={originalEmployeeId}
          patient={patient}
          type={type || "plan"}
        />
      ),
    },
  ];

  return (
    <Modal
      maskClosable={false}
      title={null}
      destroyOnClose={true}
      width={"max-content"}
      styles={{
        body: {
          padding: "2px 0 0 0",
        },
      }}
      closable={false}
      open={visible}
      onCancel={handleCancel}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
      footer={null}
    >
      <StepsWizard
        steps={steps}
        onMouseOver={onMouseOver}
        onMouseOut={onMouseOut}
        onChangeSlide={onChangeSlide}
        current={current}
        handleCancel={handleCancel}
      />
    </Modal>
  );
};

export default EventModal;
